<ng-container *transloco="let t">
  <div id="paypal-buttons"></div>
  <div *ngIf="isProcessing" class="mt2 flex-column align-center gap-10">
    <mat-spinner [diameter]="35"></mat-spinner>
    <span>{{ t('GENERIC_WRAPPER.LOADING')}}</span>
  </div>
</ng-container>
